"use client";

import { useEffect, useState } from "react";
import { useI18n } from "@/i18n/client";
import { initBuilder } from "@/lib/builder/builder-utils";
import clsx from "clsx";
import { isValidJSON } from "@/utils/is-valid-json";
import { useProductContext } from "@/providers/ProductContextProvider";
import { getArticlesSortedByDate } from "@/lib/builder/server-quries";
import * as Accordion from "@radix-ui/react-accordion";
import IconArrow from "../../UI/Icon/IconArrow/IconArrow";
import Document from "../Documentation/Document";
import NewsCard from "../../News/NewsCard/NewsCard";
import docStyles from "../Documentation/Documentation.module.scss";
import accordionStyles from "../ProductPageAccordian.module.scss";
import styles from "./AdditionalInformation.module.scss";
import useStoreKeys from "@/hooks/useStoreKeys";

const AdditionalInformation: React.FC = () => {
	const { store, lang } = useStoreKeys();
	const t = useI18n();
	const { product } = useProductContext();
	const [newsArticles, setNewsArticles] = useState<any>([]);
	const documents = isValidJSON(product.warranty).additional_files;
	initBuilder();

	useEffect(() => {
		const fetchNewsArticles = async () => {
			if (!product) return;

			const articleKey = product.customFields?.find(
				(field) => field.name === "Akeneo|Family",
			)?.value;

			if (articleKey) {
				const data = await getArticlesSortedByDate("news", {
					webStore: store,
					tags: [articleKey],
					limit: 3,
				});

				setNewsArticles(data);
			}
		};

		fetchNewsArticles();
	}, [product.id]);

	if (
		(!documents || documents.length <= 0) &&
		(!newsArticles || newsArticles.length <= 0)
	)
		return <></>;

	return (
		<Accordion.Item value='AdditionalInformation'>
			<Accordion.Header>
				<Accordion.Trigger className={accordionStyles.header}>
					<div className={accordionStyles.widthContainer}>
						{t("product.additionalInformation")}
						<IconArrow
							direction='down'
							aria-labelledby='directional chevron pointing down'
						/>
					</div>
				</Accordion.Trigger>
			</Accordion.Header>
			<Accordion.Content className={accordionStyles.content}>
				<div className={clsx([accordionStyles.widthContainer, styles.column])}>
					{documents && (
						<div className={docStyles.documentationWrapper}>
							{documents?.map(
								(
									document: { file_name: string; file_url: string },
									index: number,
								) => (
									<Document
										key={`${index}-${document.file_url}`}
										file_url={document.file_url}
										file_name={document.file_name}
									/>
								),
							)}
						</div>
					)}
					{newsArticles && (
						<div className={styles.articles}>
							{newsArticles.map((article: any) => (
								<NewsCard
									key={article.id}
									title={article.data?.title}
									link={article.data?.url}
									date={
										article.data?.date
											? new Date(article.data?.date)
											: undefined
									}
									image={article.data?.featuredImage}
								/>
							))}
						</div>
					)}
				</div>
			</Accordion.Content>
		</Accordion.Item>
	);
};

export default AdditionalInformation;
